import styled from '@emotion/styled';
import Icon from '../Icon';
import LockIcon from '../../../assets/svg/lock-check-fill.svg';
import { colors, spacing } from '../../../utils/styleguide';
import Typography, { TypographyVariants } from '../text/Typography';
import { css } from '@emotion/react';
import React from 'react';

const PaymentFooterContainer = styled.div`
  padding: ${spacing[3]}px;
`;

const StyledLockIcon = styled(LockIcon)`
  path:nth-of-type(1) {
    stroke: ${colors.darkGrey};
  }
  path:nth-of-type(2) {
    fill: ${colors.darkGrey};
  }
`;

const SecurePayments = styled.div`
  display: flex;
  padding-bottom: ${spacing[1]}px;

  svg,
  p {
    padding-right: ${spacing[1]}px;
  }
`;

const PaymentFooter = ({
  securePaymentsLabel,
  termsAndPrivacyCopyright: { donationTerms, terms, and, privacy },
}: {
  securePaymentsLabel?: string;
  termsAndPrivacyCopyright: Record<string, string>;
}) => {
  return (
    <PaymentFooterContainer>
      {securePaymentsLabel && (
        <SecurePayments>
          <StyledLockIcon />
          <Typography variant="detail" color={colors.darkGrey}>
            {securePaymentsLabel}
          </Typography>
          <Icon fill={colors.darkGray} name="visa-solid" />
          <Icon fill={colors.darkGray} name="mastercard-solid" />
          <Icon fill={colors.darkGray} name="american-express-solid" />
          <Icon fill={colors.darkGray} name="paypal-solid" />
        </SecurePayments>
      )}
      <Typography variant="detail" color={colors.darkGrey} useBuiltInMargins>
        <>
          {`${donationTerms} `}
          <Link href="/page/terms-of-use">{terms}</Link>
          {` ${and} `}
          <Link href="/privacy-notice">{privacy}</Link>
        </>
      </Typography>
    </PaymentFooterContainer>
  );
};

type LinkProps = {
  href?: string;
  color?: string;
  variant?: TypographyVariants;
  children?: string;
};

const Link = ({
  href = '',
  color = colors.blueDark,
  variant = 'detailBold',
  children,
}: LinkProps) => (
  <Typography
    useBuiltInMargins
    variant={variant}
    tag="a"
    href={href}
    css={css`
      color: ${color};

      :hover {
        cursor: pointer;
      }
    `}
  >
    {children}
  </Typography>
);

export default PaymentFooter;
